import React, { useState } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import useScript from '../../config/useScript';
import '../../config/style.css';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import BusinessIcon from '@material-ui/icons/Business';
import { Box } from '@material-ui/core';
import { useEffect } from 'react';
import LazyImage from '../common/LazyImage';
import DataConnectorIcon from '../../assets/images/logos/main_inverse.png';
import useCaptureEvent from '../../config/useCaptureEvent';
import { preserveTrackingParams } from '../../utils/hubspotTracking';
import { ButtonFilled } from '../utils/button';
import UseCasesMenu from './UseCasesMenu';

export default function Navigation() {
    const [isResourcesOpen, setIsResourcesOpen] = useState(false);
    const [isDocumentationOpen, setIsDocumentationOpen] = useState(false);
    const [isSolutionsOpen, setIsSolutionsOpen] = useState(false);
    const [isUseCasesOpen, setIsUseCasesOpen] = useState(false);
    useCaptureEvent();

    useScript();

    function openDrawer(open = true) {
        var x = document.getElementById("myTopnav");
        if (open && x.className === "topnav") {
            x.className += " responsive change";
        } else {
            x.className = "topnav";
        }
    }

    const location = useLocation()
    useEffect(() => {
        openDrawer(false)
        setIsResourcesOpen(false)
        setIsDocumentationOpen(false)
        setIsSolutionsOpen(false)
        setIsUseCasesOpen(false)
    }, [location])

    return (
        <>
            <nav className="topnav" id="myTopnav" role="navigation" aria-label="Main navigation">
                <div className="nav-brand">
                    <NavLink to="/" style={{ display: "flex", alignItems: "center", margin: 0, textDecoration: "none", gap: "10px" }} aria-label="Data Connector home">
                        <LazyImage 
                            src={DataConnectorIcon} 
                            className="nav-logo-img" 
                            alt=""
                            priority={true}
                            width={150}
                            height={50}
                            sizes="150px"
                        />
                        <span className="nav-brand-title">data connector</span>
                    </NavLink>
                </div>
                {/* <div className="is-active">{isActive}</div> */}
                <ul className="nav-links" role="menubar">
                    <li role="none">
                        <NavLink exact to="/" className="nav-link" activeClassName="active-link" role="menuitem">
                            Home
                        </NavLink>
                    </li>
                    <li role="none">
                        <NavLink to="/platform" className="nav-link" activeClassName="active-link" role="menuitem">
                            Platform
                        </NavLink>
                    </li>
                    <li
                        className={`nav-link solutions-dropdown ${location.pathname === '/solutions' || location.pathname.startsWith('/solutions/') || location.pathname === '/reporting' ? 'active-link' : ''}`}
                        onMouseEnter={() => setIsSolutionsOpen(true)}
                        onMouseLeave={() => setIsSolutionsOpen(false)}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (window.innerWidth <= 1024) {
                                setIsSolutionsOpen(!isSolutionsOpen);
                            }
                        }}
                    >
                        <div className="solutions-dropdown-container">
                            <span onClick={(e) => e.stopPropagation()}>
                                Solutions
                            </span>
                            {isSolutionsOpen && (
                                <div className="dropdown-menu expanded">
                                    <div className="dropdown-section-items">
                                        <NavLink to="/solutions" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M8 7h8M8 11h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">All solutions</div>
                                                    <div className="dropdown-item-description">Find your path—personas and popular setups</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/reporting" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9 17H15M9 13H15M9 9H11M7 21H17C18.1046 21 19 20.1046 19 19V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V19C5 20.1046 5.89543 21 7 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M13 9H17M13 13H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Reporting</div>
                                                    <div className="dropdown-item-description">Automated reporting for teams that live in spreadsheets</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/solutions/marketing-agencies" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Marketing agencies</div>
                                                    <div className="dropdown-item-description">Client reporting that updates itself</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/solutions/marketing-teams" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M18 8H19C20.0609 8 21.0783 8.42143 21.8284 9.17157C22.5786 9.92172 23 10.9391 23 12V19C23 20.0609 22.5786 21.0783 21.8284 21.8284C21.0783 22.5786 20.0609 23 19 23H5C3.93913 23 2.92172 22.5786 2.17157 21.8284C1.42143 21.0783 1 20.0609 1 19V12C1 10.9391 1.42143 9.92172 2.17157 9.17157C2.92172 8.42143 3.93913 8 5 8H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M15 4H9C7.89543 4 7 4.89543 7 6V8H17V6C17 4.89543 16.1046 4 15 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M12 12V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M10 14H14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Marketing teams</div>
                                                    <div className="dropdown-item-description">All your marketing data in one place</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/solutions/small-business" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Small business</div>
                                                    <div className="dropdown-item-description">Sales, orders, and reports—without spreadsheet drift</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/solutions/operations" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Operations</div>
                                                    <div className="dropdown-item-description">Keep systems and teams aligned automatically</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                        <NavLink to="/solutions/finance" className="dropdown-item" onClick={() => setIsSolutionsOpen(false)}>
                                            <div className="dropdown-item-content">
                                                <div className="dropdown-item-icon">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 2V22M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                                <div className="dropdown-item-text">
                                                    <div className="dropdown-item-title">Finance</div>
                                                    <div className="dropdown-item-description">Numbers you can trust without manual reconciliation</div>
                                                </div>
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                            )}
                        </div>
                    </li>
                    <li
                        className={`nav-link use-cases-dropdown ${location.pathname === '/use-cases' || location.pathname.startsWith('/use-case/') ? 'active-link' : ''}`}
                        onMouseEnter={() => setIsUseCasesOpen(true)}
                        onMouseLeave={() => setIsUseCasesOpen(false)}
                        onClick={(e) => {
                            e.stopPropagation();
                            if (window.innerWidth <= 1024) {
                                setIsUseCasesOpen(!isUseCasesOpen);
                            }
                        }}
                    >
                        <div className="use-cases-dropdown-container">
                            <span onClick={(e) => e.stopPropagation()}>Use Cases</span>
                            {isUseCasesOpen && (
                                <div className="dropdown-menu expanded">
                                    <div className="dropdown-section-items">
                                        <UseCasesMenu onNavigate={() => setIsUseCasesOpen(false)} />
                                    </div>
                                </div>
                            )}
                        </div>
                    </li>
                    <li role="none">
                        <NavLink to="/connectors" className="nav-link" activeClassName="active-link" role="menuitem">
                            Connectors
                        </NavLink>
                    </li>
                    <li role="none">
                        <NavLink to="/pricing" className="nav-link" activeClassName="active-link" role="menuitem">
                            Pricing
                        </NavLink>
                    </li>
                    <li 
                        className={`nav-link documentation-dropdown ${location.pathname.startsWith('/documentation') ? 'active-link' : ''}`}
                        onMouseEnter={() => setIsDocumentationOpen(true)}
                        onMouseLeave={() => setIsDocumentationOpen(false)}
                        onClick={(e) => {
                            // Prevent event bubbling to avoid triggering dropdown items
                            e.stopPropagation();
                            // Toggle dropdown on mobile (matches CSS breakpoint for hamburger)
                            if (window.innerWidth <= 1024) {
                                setIsDocumentationOpen(!isDocumentationOpen);
                            }
                        }}
                    >
                        <div className="documentation-dropdown-container">
                            <span onClick={(e) => e.stopPropagation()}>Documentation</span>
                            {isDocumentationOpen && (
                                <div className="dropdown-menu expanded">
                                <div className="dropdown-section-items">
                                    <NavLink to="/documentation" className="dropdown-item" onClick={() => setIsDocumentationOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Documentation</div>
                                                <div className="dropdown-item-description">Guides, articles, and resources</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/documentation/connectors" className="dropdown-item" onClick={() => setIsDocumentationOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Connector Documentation</div>
                                                <div className="dropdown-item-description">Setup guides for all connectors</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/documentation/how-to-guides" className="dropdown-item" onClick={() => setIsDocumentationOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M8 7h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M8 11h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">How-to guides</div>
                                                <div className="dropdown-item-description">Export, sync, and connect data step-by-step</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                            )}
                        </div>
                    </li>

                    <li 
                        className="nav-link resources-dropdown"
                        onMouseEnter={() => setIsResourcesOpen(true)}
                        onMouseLeave={() => setIsResourcesOpen(false)}
                        onClick={(e) => {
                            // Prevent event bubbling to avoid triggering dropdown items
                            e.stopPropagation();
                            // Toggle dropdown on mobile (matches CSS breakpoint for hamburger)
                            if (window.innerWidth <= 1024) {
                                setIsResourcesOpen(!isResourcesOpen);
                            }
                        }}
                    >
                        <div className="resources-dropdown-container">
                            <span onClick={(e) => e.stopPropagation()}>Resources</span>
                            {isResourcesOpen && (
                                <div className="dropdown-menu expanded">
                                <div className="dropdown-section-items">
                                    <NavLink to="/professional-services" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                                                                                                                     <div className="dropdown-item-icon">
                                                <BusinessIcon style={{ fontSize: 24, color: 'currentColor' }} />
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Professional Services</div>
                                                <div className="dropdown-item-description">Expert implementation and consulting</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/support" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                                                                         <div className="dropdown-item-icon">
                                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                     <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                 </svg>
                                             </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Support</div>
                                                <div className="dropdown-item-description">Get help when you need it</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/blog" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M14 2V8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M16 13H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M16 17H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M10 9H9H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Articles &amp; Comparisons</div>
                                                <div className="dropdown-item-description">ETL comparisons, best practices, and insights</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/security" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                                                                         <div className="dropdown-item-icon">
                                                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                     <path d="M12 22S20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                 </svg>
                                             </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Security & Compliance</div>
                                                <div className="dropdown-item-description">Trust and safety information</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/system-status" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">System Status</div>
                                                <div className="dropdown-item-description">Real-time service status and uptime</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                    <NavLink to="/releases" className="dropdown-item" onClick={() => setIsResourcesOpen(false)}>
                                        <div className="dropdown-item-content">
                                            <div className="dropdown-item-icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9 12H15M9 16H15M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H12.5858C12.851 3 13.1054 3.10536 13.2929 3.29289L19.7071 9.70711C19.8946 9.89464 20 10.149 20 10.4142V19C20 20.1046 19.1046 21 18 21H17ZM17 21V9H13V5H7V19H17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </div>
                                            <div className="dropdown-item-text">
                                                <div className="dropdown-item-title">Releases</div>
                                                <div className="dropdown-item-description">Version history and changelog</div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            </div>
                        )}
                        </div>
                    </li>
                    {/* <li>
                        <NavLink to="/company" className="nav-link" activeClassName="active-link">
                            Company
                        </NavLink>
                    </li> */}
                    {/* <li>
                        <NavLink to="/customers" className="nav-link" activeClassName="active-link">
                            Customers
                        </NavLink>
                    </li> */}
                    {/* <li>
                        <NavLink to="/company" className="nav-link" onClick={() => setActive("LOG IN")}>
                            Community
                        </NavLink>
                    </li> */}
                    {/* <li>
                        <NavLink to="/resources" className="nav-link" activeClassName="active-link">
                            Resources
                        </NavLink>
                    </li> */}
                </ul>
                <div className='nav-2'>
                    <NavLink to="/login">
                        <ButtonFilled
                            size="medium"
                            borderColor="rgba(148, 163, 184, 0.45)"
                            fontColor="#e2e8f0"
                            fillColor="rgba(255, 255, 255, 0.06)"
                        >
                            Log in
                        </ButtonFilled>
                    </NavLink>
                    <NavLink to={preserveTrackingParams('/register-company')} style={{ textDecoration: 'none' }}>
                        <Box
                            className="nav-cta-try-free"
                            style={{
                                background: 'linear-gradient(135deg, #fb923c 0%, #f97316 42%, #ea580c 100%)',
                                color: '#fff',
                                padding: '8px 18px',
                                borderRadius: '14px',
                                fontWeight: 600,
                                fontSize: '14px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                boxShadow:
                                    '0 4px 22px rgba(249, 115, 22, 0.42), 0 0 36px rgba(251, 146, 60, 0.28), inset 0 1px 0 rgba(255,255,255,0.22)',
                                border: '1px solid rgba(253, 186, 116, 0.4)',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                                e.currentTarget.style.boxShadow =
                                    '0 8px 32px rgba(249, 115, 22, 0.5), 0 0 44px rgba(251, 146, 60, 0.35), inset 0 1px 0 rgba(255,255,255,0.26)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow =
                                    '0 4px 22px rgba(249, 115, 22, 0.42), 0 0 36px rgba(251, 146, 60, 0.28), inset 0 1px 0 rgba(255,255,255,0.22)';
                            }}
                        >
                            Try for free
                        </Box>
                    </NavLink>

                    <IconButton aria-label="Menu" className="hamburger-menu" onClick={openDrawer}>
                        <MenuIcon fontSize="small" />
                    </IconButton>
                </div>
            </nav>
        </>
    );
}